import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  width: 70px;
  min-height: 70px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${media.xs`
    background: none;
  `}
`

export default class YouTubeIcon extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="35"
          height="43"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.605 30.853H27.3l.01-1.345a1.09 1.09 0 0 1 1.086-1.086h.147a1.09 1.09 0 0 1 1.088 1.086l-.026 1.345zm-8.646-2.881c-.584 0-1.063.394-1.063.877v6.54c0 .482.479.876 1.063.876.587 0 1.066-.394 1.066-.876v-6.54c0-.483-.479-.877-1.066-.877zM35 24.314v12.44c0 2.984-2.576 5.425-5.726 5.425H5.726C2.576 42.18 0 39.738 0 36.754v-12.44c0-2.984 2.576-5.426 5.726-5.426h23.548c3.15 0 5.726 2.442 5.726 5.426zM7.297 38.104L7.295 25l2.92.001V23.06l-7.782-.012v1.909l2.43.007v13.14h2.434zm8.75-11.152h-2.433v6.998c0 1.012.06 1.518-.004 1.697-.198.543-1.087 1.119-1.434.058-.059-.185-.007-.745-.008-1.707l-.01-7.046h-2.42l.007 6.935c.002 1.063-.023 1.856.009 2.217.06.636.038 1.377.626 1.8 1.094.793 3.193-.117 3.718-1.25l-.005 1.445 1.955.003v-11.15zm7.786 8.013l-.005-5.824c-.002-2.22-1.656-3.548-3.9-1.752l.01-4.33-2.431.003-.012 14.946 2-.03.182-.93c2.554 2.353 4.16.74 4.156-2.083zm7.616-.771l-1.825.01c0 .072-.003.156-.004.247v1.023c0 .547-.45.993-.997.993h-.358a.999.999 0 0 1-.998-.993V32.784h4.178v-1.58c0-1.153-.029-2.307-.124-2.967-.3-2.088-3.217-2.419-4.69-1.35-.463.333-.816.78-1.022 1.38-.207.6-.31 1.42-.31 2.462v3.473c0 5.773 6.983 4.957 6.15-.008zM22.09 15.34c.125.307.32.555.585.743.261.184.595.277.996.277.35 0 .662-.095.932-.291.27-.196.497-.488.683-.877l-.046.959h2.712V4.565h-2.135v9.017c0 .488-.4.888-.89.888a.892.892 0 0 1-.888-.888V4.565h-2.23v7.814c0 .996.019 1.66.048 1.996.03.334.107.654.233.965zm-8.221-6.543c0-1.112.092-1.98.276-2.607.185-.624.516-1.125.997-1.503.48-.38 1.093-.57 1.84-.57.627 0 1.164.123 1.613.365.452.244.8.56 1.041.95.246.393.413.795.502 1.207.091.418.136 1.048.136 1.897v2.93c0 1.075-.043 1.866-.127 2.367-.082.504-.26.97-.534 1.408a2.54 2.54 0 0 1-1.044.964c-.429.208-.919.31-1.472.31-.618 0-1.14-.085-1.569-.264a2.155 2.155 0 0 1-1-.803c-.24-.358-.408-.793-.51-1.3-.102-.506-.15-1.268-.15-2.284V8.797zm2.125 4.602c0 .656.486 1.192 1.078 1.192.593 0 1.077-.536 1.077-1.192V7.231c0-.655-.484-1.19-1.077-1.19-.592 0-1.078.535-1.078 1.19V13.4zm-7.508 3.114h2.56l.002-8.886L14.07.015h-2.8L9.665 5.67 8.034 0h-2.77L8.48 7.632l.004 8.881z"
            fill="#FFF"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Footer/YouTubeIcon.js